import { adminService } from '../services'

export const admin = {
    namespaced: true,
    state: {
        all: {},
        teams: {},
        reviewer:{},
        loading: true,
        total: 0,
        regions:{},
    },
    actions: {
        collegeStatus({ commit }) {
            commit('REGISTRATION_STATUS_FETCH')

            adminService.collegeStatus()
                .then(
                    status => commit('REGISTRATION_STATUS_SUCCESS', status),
                    error => commit('REGISTRATION_STATUS_FAIL', error)
                )
        },
        individualCollegeParticipation({ commit },{collegeId}){
            commit('COLLEGE_INDIVIDUAL_FETCH')

            adminService.individualCollegeParticipation(collegeId)
                    .then(
                        teams => commit('COLLEGE_INDIVIDUAL_SUCCESS',teams),
                        error => commit('COLLEGE_INDIVIDUAL_FAIL',error)
                    )
        },
        getReviewerData({ commit }){
            adminService.getReviewerData()
            .then(
                payload=> commit('REVIEWER_EVALUATION_SUCCESS',payload),
                error=> commit('REVIEWER_EVALUATION_ERROR',error),
            )
        },
        getRegionalData({ commit },{params}){
            adminService.getRegionalData(params)
            .then(
                payload => commit('REGIONAL_DATA_SUCCESS', payload),
                error => commit('REGIONAL_DATA_ERROR', error),
            )
        }
    },
    mutations: {
        REGISTRATION_STATUS_FETCH(state) {
            state.all = { loading: true }
        },
        REGISTRATION_STATUS_SUCCESS(state, status) {
            state.all = { items: status }
        },

        REGISTRATION_STATUS_FAIL(state, error) {
            state.all = { error }
        },
        COLLEGE_INDIVIDUAL_FETCH(state){
            state.teams = { loading: true }
        },
        COLLEGE_INDIVIDUAL_SUCCESS(state, teams){
            state.teams = { teams: teams }
        },
        COLLEGE_INDIVIDUAL_FAIL(state, error){
            state.teams = { error }
        },
        REVIEWER_EVALUATION_SUCCESS(state,payload){
            state.reviewer=payload
        },
        REVIEWER_EVALUATION_ERROR(state,error){
            state.reviewer={error}
        },
        REGIONAL_DATA_SUCCESS(state,payload){
            state.regions=payload

            let currentTotal = payload.total
            if ((payload.total/ 20) > 1000) {
                currentTotal = 20 * 1000
            }
            state.total = currentTotal
            state.loading = false
        },
        REGIONAL_DATA_ERROR(state,error){
            state.regions={error}
        },
    }
}
